export default "__VITE_ASSET__C1pmrY5Y__"